module.exports = __webpack_public_path__ + "img/MoDesk8.7c2d355d.png";